import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  size?: number;
  /** When true, fill with the Cydea brand gradient (banner). Otherwise use `color`. */
  gradient?: boolean;
  /** Solid fill colour (used when `gradient` is false). Defaults to Davys Grey. */
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

// Filled info/alert circle (disc with an exclamation cut-out) — Figma nodes 15978:4936 (banner,
// gradient) and 15757:84339 (helper note, solid #555862). Ticket 7127.
export const InfoCircleSvg: React.FC<Props> = ({ size = 14, gradient = false, color, style, className }) => {
  const colors = useStateSelector((state) => state.theme.colors);
  const id = `infocircle_${Math.random().toString(36).slice(2)}`;
  const fill = gradient ? `url(#${id})` : color ?? colors.davysGrey;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM7.7 10.5H6.3V6.3H7.7V10.5ZM7.7 4.9H6.3V3.5H7.7V4.9Z"
        fill={fill}
      />
      {gradient && (
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="16.4101" y2="4.7401" gradientUnits="userSpaceOnUse">
            <stop offset="0.0001" stopColor={colors.gp1} />
            <stop offset="1" stopColor={colors.gp2} />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};
